<template>
  <div v-if="emailTemplate">
    <h1>Email template</h1>
    <v-btn :to="{name:'emailTemplates'}">
      <v-icon>chevron_left</v-icon>Email templates
    </v-btn>
    <v-alert
      :value="true"
      type="info"
    >Please note that the "Dear &lt;Client Name&gt;," and "Kind Regards, &lt;Conveyancer Name&gt;" parts will be added to top and bottom of the template before the email is sent. So there is no need to add them here.</v-alert>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-text-field label="Name" v-model="emailTemplate.name" outline v-on="on" />
      </template>
      <span>This is only used to identify the template in a list</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-text-field label="Subject" v-model="emailTemplate.subject" outline v-on="on" />
      </template>
      <span>The subject for the email</span>
    </v-tooltip>
    <v-btn-toggle v-model="editorMode" mandatory>
      <v-btn flat small value="source">Source</v-btn>
      <v-btn flat small value="rich">Richtext</v-btn>
    </v-btn-toggle>
    <quill-editor v-model="emailTemplate.body" v-if="editorMode == 'rich'" />
    <v-textarea
      v-model="emailTemplate.body"
      v-if="editorMode == 'source'"
      label="Body"
      outline
      required
    />
    <v-checkbox label="Archived" v-model="emailTemplate.archived" />
    <v-checkbox label="Default" v-model="emailTemplate.defaulted" />
    <h3>Tags</h3>
    <v-checkbox
      v-for="tag in tags"
      :key="tag.id"
      v-model="selectedTags"
      :value="tag.id"
      :label="tag.name"
    />
    <v-btn @click="saveEmailTemplate">
      <v-icon>save</v-icon>Save
    </v-btn>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "EmailTemplate",
  metaInfo() {
    return {
      title: "Email template",
      titleTemplate: "%s - Documents - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      emailTemplate: null,
      emailTemplateTags: null,
      tags: null,
      selectedTags: [],
      editorMode: "rich"
    };
  },
  methods: {
    fetchEmailTemplate() {
      nbmlaw
        .get(`/cors/admin/document/emailTemplates/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data)
          this.emailTemplate = response.data;
        });
    },
    fetchEmailTemplateTags() {
      nbmlaw
        .get(
          `/cors/admin/document/emailTemplates/${this.$route.params.id}/tags`
        )
        .then(response => {
          // console.log(response.data)
          this.emailTemplateTags = response.data;
        });
    },
    fetchEmailTemplatesTags() {
      nbmlaw.get(`/cors/admin/document/emailTemplateTags`).then(response => {
        // console.log(response.data);
        this.tags = response.data;
      });
    },
    async saveEmailTemplate() {
      if (this.$route.params.id) {
        this.updateEmailTemplate();
      } else {
        this.createEmailTemplate();
      }
    },
    createEmailTemplate() {
      nbmlaw
        .post(`/cors/admin/document/emailTemplates`, this.emailTemplate, {
          params: { selectedTags: this.selectedTags.join(".") }
        })
        .then(() => {
          // console.log(response.data)
          this.$router.push({ name: "emailTemplates" });
        });
    },
    updateEmailTemplate() {
      nbmlaw
        .put(
          `/cors/admin/document/emailTemplates/${this.$route.params.id}`,
          this.emailTemplate,
          { params: { selectedTags: this.selectedTags.join(".") } }
        )
        .then(() => {
          // console.log(response.data)
          this.$router.push({ name: "emailTemplates" });
        });
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchEmailTemplate();
          this.fetchEmailTemplateTags();
        } else {
          this.emailTemplate = {};
        }
      }
    },
    emailTemplateTags: {
      handler() {
        if (this.emailTemplateTags) {
          this.selectedTags = this.emailTemplateTags.map(t => {
            return t.id;
          });
        } else {
          this.selectedTags = [];
        }
      }
    }
  },
  created() {
    this.fetchEmailTemplatesTags();
  }
};
</script>
